// extracted by mini-css-extract-plugin
export default {"accountName":"HeaderMenu_accountName__Hg3VN","menuItem":"HeaderMenu_menuItem__IUz4B"};